import { ErrorHandler, Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular-ivy';

const CHUNK_FAILED_PATTERN = /Loading chunk [\d]+ failed/;

// Deploys delete the previous hashed chunks from S3, so a tab opened before a
// deploy gets "Loading chunk failed" on its first visit to a lazy route. A
// reload picks up the new index.html and fixes it. The throttle prevents a
// reload loop when the failure is persistent (offline, CDN outage): within
// the window we report to Sentry instead of reloading again.
const RELOAD_THROTTLE_KEY = 'chunk-failed-reload-at';
const RELOAD_THROTTLE_MS = 30_000;

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly sentryHandler: ErrorHandler = Sentry.createErrorHandler({
    showDialog: false,
  });

  handleError(error: any): void {
    if (CHUNK_FAILED_PATTERN.test(error?.message ?? '')) {
      const lastReloadAt = Number(
        sessionStorage.getItem(RELOAD_THROTTLE_KEY) ?? 0
      );
      if (Date.now() - lastReloadAt > RELOAD_THROTTLE_MS) {
        sessionStorage.setItem(RELOAD_THROTTLE_KEY, String(Date.now()));
        const { href } = window.location;
        window.location.href = href;
        return;
      }
    }
    this.sentryHandler.handleError(error);
  }
}
